import "./App.css";
import $ from "jquery";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import DataProvider from "./data/Context";
import store from "./data/Store";
import { BrowserRouter as Router } from "react-router-dom";
import Routers from "./Routes";
import { useEffect } from "react";
import { TOKEN, loadUser } from "./data/Reducers/UserReducer";
import { SetAuthToken, SetDefaultHeaders } from "./data/Config";
import LogoBB from "./assets/logo.svg";

// Preloader
$(window).on("load", function () {
  $(".lds-ellipsis").fadeOut(); // will first fade out the loading animation
  $(".preloader").delay(333).fadeOut("slow"); // will fade out the white DIV that covers the website.
  $("body").delay(333);
});

SetDefaultHeaders();

if (localStorage.getItem(TOKEN)) {
  SetAuthToken(localStorage.getItem(TOKEN));
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_NAME === "Brain Builder") {
      let link = document.querySelector("link[rel~='icon']");
      let link2 = document.querySelector("link[rel~='apple-touch-icon']");
      // let title = document.querySelector("title");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      if (!link2) {
        link2 = document.createElement("link");
        link2.rel = "apple-touch-icon";
        document.getElementsByTagName("head")[0].appendChild(link2);
      }
      link.href = LogoBB;
      link2.href = LogoBB;
    }
  }, []);

  return (
    <Provider store={store}>
      <DataProvider>
        <Router>
          <Routers />
        </Router>
      </DataProvider>
    </Provider>
  );
};

export default App;

// 123456677
// Super@1234
